import { useState } from "react";
import { useRule } from "../CreateRuleNew/RuleReducer";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import Button3 from "../../../Button/Button3";
import classes from "./RuleWizard.module.css";

const TIMEFRAME_UNITS = [
    { label: "Seconds", value: 1000 },
    { label: "Minutes", value: 60000 },
    { label: "Hours",   value: 3600000 },
];

const WizardStepDeadlineTimeframe = ({ onNext, onBack }) => {
    const { state, dispatch } = useRule();

    const initialTimeframe = (() => {
        const ms = state.timeframe_window_ms;
        if (!ms) return { value: "", unit: 60000 };
        if (ms % 3600000 === 0) return { value: ms / 3600000, unit: 3600000 };
        if (ms % 60000 === 0) return { value: ms / 60000, unit: 60000 };
        return { value: ms / 1000, unit: 1000 };
    })();
    const [timeframeValue, setTimeframeValue] = useState(initialTimeframe.value);
    const [timeframeUnit, setTimeframeUnit] = useState(initialTimeframe.unit);

    const canProceed = timeframeValue > 0;

    return (
        <>
            <div className={classes.contentHeader}>
                <h2 className={classes.contentTitle}>Check timing</h2>
                <p className={classes.contentSubtitle}>
                    This rule only has one trigger condition, so its timeframe wasn't set earlier. Since you've
                    added a status check, set how long after the trigger fires it should be evaluated.
                </p>
            </div>

            <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: "14px" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                        <span style={{ fontSize: "12px", color: "#6e6e6e" }}>Within:</span>
                        <InputNumber
                            value={timeframeValue === "" ? null : Number(timeframeValue)}
                            onValueChange={(e) => {
                                const val = e.value ?? "";
                                setTimeframeValue(val);
                                dispatch({
                                    type: "SET_TIMEFRAME_WINDOW_MS",
                                    payload: val > 0 ? Number(val) * timeframeUnit : null,
                                });
                            }}
                            min={1}
                            style={{ width: "80px", flexShrink: 0 }}
                            inputStyle={{ width: "80px" }}
                            placeholder=""
                        />
                        <Dropdown
                            value={timeframeUnit}
                            options={TIMEFRAME_UNITS}
                            onChange={(e) => {
                                setTimeframeUnit(e.value);
                                if (timeframeValue > 0) {
                                    dispatch({ type: "SET_TIMEFRAME_WINDOW_MS", payload: Number(timeframeValue) * e.value });
                                }
                            }}
                            style={{ width: "180px", flexShrink: 0 }}
                        />
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                        <span style={{ fontSize: "12px", color: "#6e6e6e" }}>Window:</span>
                        <Button3
                            style={{
                                minWidth: "90px", minHeight: "30px", fontSize: "12px",
                                backgroundColor: state.timeframe_window_mode === "FIXED" ? "var(--Primary-Color)" : undefined,
                                color: state.timeframe_window_mode === "FIXED" ? "white" : undefined,
                            }}
                            onClick={() => dispatch({ type: "SET_TIMEFRAME_WINDOW_MODE", payload: "FIXED" })}
                        >
                            Fixed
                        </Button3>
                        <Button3
                            style={{
                                minWidth: "90px", minHeight: "30px", fontSize: "12px",
                                backgroundColor: state.timeframe_window_mode === "SLIDING" ? "var(--Primary-Color)" : undefined,
                                color: state.timeframe_window_mode === "SLIDING" ? "white" : undefined,
                            }}
                            onClick={() => dispatch({ type: "SET_TIMEFRAME_WINDOW_MODE", payload: "SLIDING" })}
                        >
                            Sliding
                        </Button3>
                    </div>
                    <p style={{ margin: 0, fontSize: "12px", color: "#6e6e6e" }}>
                        {state.timeframe_window_mode === "SLIDING"
                            ? "Sliding: the countdown restarts every time the trigger fires again, as long as it happens within the window."
                            : "Fixed: the countdown starts once the trigger fires and keeps running, even if it fires again within the window."}
                    </p>
                </div>
            </div>

            <div className={classes.navRow}>
                <Button label="Back" icon="pi pi-arrow-left" severity="secondary" outlined onClick={onBack} />
                <Button label="Next" icon="pi pi-arrow-right" iconPos="right" severity="success" disabled={!canProceed} onClick={onNext} />
            </div>
        </>
    );
};

export default WizardStepDeadlineTimeframe;
